export default __webpack_public_path__ + "afc9dc76685341df0cbc486fe680da3a.svg";